import styled from 'styled-components';

const TotalCustomerStyled = styled.div`
  background: #ffffff;
  margin-top: 12px;
  border-radius: 12px;
  padding: 24px 32px;
  .customer-wrap {
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 64px;
  }
  .sales-left {
    .sales-top-wrap {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .sales-icon-wrap {
        display: flex;
        flex-direction: row;
        div {
          font-size: 18px;
          font-family: 'SourceHanSansCNMedium', sans-serif;
          margin-left: 12px;
          /* font-family: SourceHanSansCN-Medium, SourceHanSansCN; */
          font-weight: 500;
          color: #424242;
          line-height: 27px;
        }
        .customer-num-wrap {
          width: 136px;
          display: flex;
          flex-direction: row;
          position: relative;
        }
      }
      .sales-evol-wrap-bottom {
        display: flex;
        justify-content: space-between;
        align-items: end;
        gap: 21px;
        align-items: baseline;
        .sales-evol-wrap-bottom-left {
          display: flex;
          justify-content: space-between;
          width: 166px;
        }
      }
      .sales-evol-wrap {
        display: flex;
        flex-direction: column;
        gap: 15px;
        .sales-evol-wrap-top {
          display: flex;
          justify-content: end;
          align-items: end;
          gap: 21px;
          align-items: baseline;
          .sales-evol-wrap-top-left {
            display: flex;
            justify-content: space-between;
            gap: 17px;
          }
        }
        .sales-evol-wrap-top-right {
          display: flex;
          justify-content: space-between;
          word-break: keep-all;
          width: 113px;
        }
        div {
          display: flex;
          .amount-tag {
            font-size: 36px;
            font-family: CenturyGothic-Bold, Century Gothic;
            font-weight: bold;
            color: #1d8fc0;
            line-height: 44px;
          }
          .amount-paa {
            font-size: 16px;
            font-family: 'SourceHanSansCNRegular', sans-serif;
            font-weight: 400;
            color: #424242;
            line-height: 24px;
            display: flex;
            flex-direction: row;
            position: relative;
          }
          .amount-paa-num {
            font-size: 18px;
            /* font-family: 'MontserratMedium', sans-serif; */
            color: #424242;
            font-family: CenturyGothic-Bold, Century Gothic;
            font-weight: bold;
            line-height: 22px;
          }
          .percent-up {
            color: #4caf50;
          }
          .percent-down {
            color: #ff9800;
          }
          .percent-up,
          .percent-down {
            text-align: right;
            /* width: 100%; */
            display: flex;
            justify-content: end;
            align-items: center;
            font-size: 14px;
            font-family: CenturyGothic-Bold, Century Gothic;
            /* font-family: 'MontserratRegular', sans-serif; */
          }
        }
        .amount-evol {
          font-size: 18px;
          line-height: 22px;
          font-size: 14px;
          /* font-family: 'SourceHanSansCNRegular', sans-serif; */
          font-weight: 400;
          color: #424242;
        }
        .amount-number {
          text-align: right;
        }
        .amount-percent {
          text-align: right;
          font-size: 18px;
          line-height: 22px;
        }
      }
    }
    .sales-bottom-wrap {
      margin-left: 34px;
      height: 37px;
      position: relative;
      .member-percent {
        display: flex;
        justify-content: space-between;
        margin: 31px 0 3px;
        span {
          display: flex;
          font-family: CenturyGothic-Bold, Century Gothic;
          /* font-family: 'MontserratRegular', sans-serif; */
          font-size: 14px;
          div {
            font-family: 'SourceHanSansCNRegular', sans-serif;
          }
        }
      }
      .progress-wrap {
        width: 100%;
        height: 12px;
        bottom: 0;
        position: absolute;
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }
  }
  .customer-right {
    display: flex;
    flex-direction: row;
    gap: 64px;
    width: 100%;
    .right-wrap {
      width: 50%;
    }
    .customer-title-wrap {
      font-size: 18px;
      font-family: 'SourceHanSansCNMedium', sans-serif;
      font-weight: 500;
      color: #424242;
      line-height: 27px;
      .customer-title {
        margin-left: 12px;
        position: relative;
      }
    }
    .customer-data-wrap {
      display: flex;
      flex-direction: row;
      /* gap: 52px; */
      margin-top: 24px;
      justify-content: space-evenly;
      /* padding: 20px 0 0 42px; */
      .customer-data-list {
        display: flex;
        flex-direction: column;
        .customer-data-list-name {
          font-size: 16px;
          font-family: 'SourceHanSansCNMedium', sans-serif;
          font-weight: 500;
          color: #424242;
          line-height: 24px;
          display: flex;
        }
        .customer-data-list-value {
          font-size: 36px;
          /* font-family: 'MontserratBold', sans-serif; */
          font-weight: bold;
          color: #1d8fc0;
          padding-top: 8px;
          display: flex;
          flex-direction: row;
          font-family: CenturyGothic-Bold, Century Gothic;
          line-height: 44px;
          .customer-data-rmb {
            /* font-family: 'SourceHanSansCNRegular', sans-serif; */
            margin-right: 12px;
            font-size: 18px;
            font-family: CenturyGothic-Bold, Century Gothic;
            font-weight: bold;
            color: #1d8fc0;
            line-height: 22px;
          }
        }
        .customer-data-list-evol {
          font-size: 14px;
          /* font-family: 'SourceHanSansCNRegular', sans-serif; */
          font-weight: 400;
          color: #424242;
          line-height: 21px;
        }
        .customer-data-list-rate {
          font-size: 14px;
          color: #4caf50;
          line-height: 24px;
          margin-left: 10px;
          font-family: CenturyGothic-Bold, Century Gothic;
          /* font-family: 'MontserratRegular', sans-serif; */
        }
        .customer-data-list-rate-down {
          color: #ff9800;
          font-size: 14px;
          /* font-family: 'MontserratRegular', sans-serif; */
          font-weight: 400;
          line-height: 24px;
          margin-left: 3px;
          font-family: CenturyGothic-Bold, Century Gothic;
        }
      }
    }
  }
`;

export default TotalCustomerStyled;
